import css from 'styled-jsx/css';

export default css`
  main {
    overflow-x: hidden;
    padding-bottom: 4rem;
    width: 100%;
  }
`;
